<template>
  <v-card-text>
    <v-layout column>
      <div class="text-center">
        <h1 class="display-3 font-weight-bold">7 Days Free Trial</h1>
        <div class="subtitle-1">
          You're
          <span class="font-weight-bold">credit card will not be charged until your 7 days </span>
          <span>trial ends. You may cancel your subscription at any time.</span>
        </div>
      </div>
      <div class="card-wrapper section mb-5"></div>
      <form id="editCard">
        <v-layout row wrap>
          <v-flex xs12 sm6="sm6">
            <v-text-field
              id="cardNumber"
              v-model.trim="Card.cardNumber"
              label="Card Number"
              @input="$v.Card.cardNumber.$touch()"
              :error-messages="CardNumberErrors"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6="sm6">
            <v-text-field
              id="nameOnCard"
              v-model.trim="Card.nameOnCard"
              @input="$v.Card.nameOnCard.$touch()"
              label="Name On Card"
              :error-messages="NameOnCardErrors"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs6="xs6">
            <v-text-field
              id="cardExpiry"
              v-model.trim="Card.cardExpiry"
              @input="$v.Card.cardExpiry.$touch()"
              label="Expiry Date"
              :error-messages="CardExpiryDateErrors"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs6="xs6">
            <v-text-field
              id="cvvCode"
              v-model.trim="Card.cvvCode"
              @input="$v.Card.cvvCode.$touch()"
              label="CVV Code"
              :error-messages="CardCVVErrors"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model.trim="Card.address"
              @input="$v.Card.address.$touch()"
              label="Address"
              :error-messages="CardAddressErrors"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4="sm4">
            <v-text-field
              v-model.trim="Card.city"
              @input="$v.Card.city.$touch()"
              label="City"
              :error-messages="CardCityErrors"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs6="xs6" sm4="sm4">
            <v-text-field
              v-model.trim="Card.state"
              @input="$v.Card.state.$touch()"
              label="State"
              :error-messages="CardStateErrors"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs6="xs6" sm4="sm4">
            <v-text-field
              v-model.trim="Card.zipcode"
              @input="$v.Card.zipcode.$touch()"
              label="Zipcode"
              :error-messages="CardZipcodeErrors"
            >
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout class="mt-3" row>
          <v-btn color="info" text>{{ $t("buttons.cancel") }}</v-btn>
          <v-spacer> </v-spacer>
          <v-btn color="info" text @click="back">{{ $t("buttons.back") }}</v-btn>
          <v-btn color="info" @click="nextStep">{{ $t("buttons.next") }}</v-btn>
        </v-layout>
      </form>
    </v-layout>
  </v-card-text>
</template>

<script>
import { mapGetters, mapState } from "vuex";
const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");
export default {
  computed: {
    ...mapState("location", ["Card"]),
    CardNumberErrors() {
      const errors = [];
      if (!this.$v.Card.cardNumber.$dirty) return errors;
      if (!this.$v.Card.cardNumber.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Card.cardNumber.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    NameOnCardErrors() {
      const errors = [];
      if (!this.$v.Card.nameOnCard.$dirty) return errors;
      if (!this.$v.Card.nameOnCard.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Card.nameOnCard.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    CardExpiryDateErrors() {
      const errors = [];
      if (!this.$v.Card.cardExpiry.$dirty) return errors;
      if (!this.$v.Card.cardExpiry.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    CardCVVErrors() {
      const errors = [];
      if (!this.$v.Card.cvvCode.$dirty) return errors;
      if (!this.$v.Card.cvvCode.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Card.cvvCode.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    CardAddressErrors() {
      const errors = [];
      if (!this.$v.Card.address.$dirty) return errors;
      if (!this.$v.Card.address.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Card.address.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    CardCityErrors() {
      const errors = [];
      if (!this.$v.Card.city.$dirty) return errors;
      if (!this.$v.Card.city.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Card.city.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    CardStateErrors() {
      const errors = [];
      if (!this.$v.Card.state.$dirty) return errors;
      if (!this.$v.Card.state.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    CardZipcodeErrors() {
      const errors = [];
      if (!this.$v.Card.zipcode.$dirty) return errors;
      if (!this.$v.Card.zipcode.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Card.zipcode.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    }
  },
  mounted() {
    var card = new Card({
      form: "form#editCard", // *required*

      container: ".card-wrapper", // *required*

      formSelectors: {
        numberInput: "input#cardNumber",
        expiryInput: "input#cardExpiry",
        cvcInput: "input#cvvCode",
        nameInput: "input#nameOnCard"
      },

      width: 200,
      formatting: true,

      // Strings for translation - optional
      messages: {
        validDate: "valid\ndate", // optional - default 'valid\nthru'
        monthYear: "mm/yy"
      },
      placeholders: {
        number: "•••• •••• •••• ••••",
        name: "Full Name",
        expiry: "••/••",
        cvc: "•••"
      },

      // if true, will log helpful messages for setting up Card
      debug: false // optional - default false
    });
  },
  methods: {
    nextStep() {
      this.$v.Card.$touch();
      if (!this.$v.Card.$invalid) {
        this.$emit("nextStep");
      }
    },
    back() {
      this.$emit("back");
    }
  },
  mixins: [validationMixin],
  validations: {
    Card: {
      cardNumber: {
        required,
        minLength: minLength(4)
      },
      nameOnCard: {
        required,
        minLength: minLength(4)
      },
      cvvCode: {
        required,
        minLength: minLength(3)
      },
      cardExpiry: {
        required
      },
      address: {
        required,
        minLength: minLength(2)
      },
      city: {
        required,
        minLength: minLength(4)
      },
      state: {
        required
      },
      zipcode: {
        required,
        minLength: minLength(4)
      }
    }
  }
};
</script>

<style scoped></style>
